import React from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

const ConfirmationPopup = ({ onClose, onAddMore, formData }) => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 1050,
      }}
    >
      <div
        className="bg-white p-4 rounded text-center shadow"
        style={{ width: 400 }}
      >
        <IoCheckmarkCircle size={48} color="#28a745" className="mb-2" />
        <h5 className="fw-bold mb-2">Event Added Successfully!</h5>
        <p className="text-muted mb-4">
          The {formData?.usecase_name} event has been successfully integrated
          with the
          <br />
          <strong>{formData?.camera_name} Camera</strong>.
        </p>

        <div className="d-flex justify-content-center gap-2">
          <button className="btn btn-outline-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={onAddMore}>
            Add More Events
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
